export default __webpack_public_path__ + "static/shanhui2-0f5491d7091fac7ec8556be26151dffb.png";